import { getCssVariable } from '@web/shared/utils/get-css-variable.util'

export const isDarkTheme = (): boolean =>
  document.documentElement.dataset.theme === 'dark'

/**
 * Chart.js рисует на canvas, поэтому цвет нужно резолвить в реальное значение.
 * lightValue — оригинальный цвет для светлой темы (оставляем как было),
 * darkCssVar — CSS-переменная, из которой берём цвет для тёмной темы.
 */
export const resolveThemeColor = (
  lightValue: string,
  darkCssVar: string
): string => (isDarkTheme() ? getCssVariable(darkCssVar) : lightValue)
